import { Nav } from '@alifd/next';
import {
  AlertOutlined,
  AliwangwangOutlined,
  ApartmentOutlined,
  AuditOutlined,
  BankOutlined,
  BarsOutlined,
  BookOutlined,
  BuildOutlined,
  BulbOutlined,
  CalendarOutlined,
  CarOutlined,
  CarryOutOutlined,
  CheckSquareOutlined,
  ClearOutlined,
  CodepenOutlined,
  CodeSandboxOutlined,
  ControlOutlined,
  CreditCardOutlined,
  CustomerServiceOutlined,
  DatabaseOutlined,
  DollarCircleOutlined,
  DollarOutlined,
  ExperimentOutlined,
  FileProtectOutlined,
  FolderOpenOutlined,
  FundOutlined,
  FundProjectionScreenOutlined,
  HomeOutlined,
  IdcardOutlined,
  InstagramOutlined,
  InsuranceOutlined,
  MailOutlined,
  MehOutlined,
  MoneyCollectOutlined,
  NotificationOutlined,
  ProfileOutlined,
  ReconciliationOutlined,
  SolutionOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  UsergroupAddOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import { Link, withRouter } from 'ice';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { findDOMNode } from 'react-dom';

import commonhelper from '@/lib/commonhelper';

import client from '../../../../lib/feathers';
// import { currentAuth } from '../../menuConfig';

const { SubNav } = Nav;
const NavItem = Nav.Item;
const Navigation = (props, context) => {
  const iconArr = [
    {
      name: '公告事項',
      icon: (
        <NotificationOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '行事曆',
      icon: (
        <CalendarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '郵件包裹',
      icon: (
        <CodepenOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '寄物管理',
      icon: (
        <CodeSandboxOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '公設預約',
      icon: (
        <ReconciliationOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '訪客管理',
      icon: (
        <SolutionOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '訪客門禁',
      icon: (
        <IdcardOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '投票活動',
      icon: (
        <BarsOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '報修服務',
      icon: (
        <ToolOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '瓦斯抄錶',
      icon: (
        <ExperimentOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '社區管理',
      icon: (
        <FileProtectOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '帳號管理',
      icon: (
        <UsergroupAddOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: 'BA系統',
      icon: (
        <ApartmentOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '意見反應',
      icon: (
        <AliwangwangOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '繳費系統',
      icon: (
        <DollarCircleOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '叫車服務管理',
      icon: (
        <DollarCircleOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '汽車充電樁EMS',
      icon: (
        <ThunderboltOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '會計系統',
      icon: (
        <AuditOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '車牌預約',
      icon: (
        <CarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '人臉訪客',
      icon: (
        <MehOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '智慧建築專區',
      icon: (
        <BankOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '清潔工作',
      icon: (
        <ClearOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '機電巡檢',
      icon: (
        <ControlOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '巡邏管理',
      icon: (
        <InsuranceOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '叫梯',
      icon: (
        <WhatsAppOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '智慧信箱',
      icon: (
        <MailOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '設備管理',
      icon: (
        <DatabaseOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '社區規範',
      icon: (
        <BookOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '社區檔案',
      icon: (
        <FolderOpenOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '社區組織管理',
      icon: (
        <ProfileOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '財務管理',
      icon: (
        <DollarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '身體量測',
      icon: (
        <FundOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '叫梯服務',
      icon: (
        <HomeOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '家庭保全',
      icon: (
        <InsuranceOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '送件服務',
      icon: (
        <BulbOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '公播管理',
      icon: (
        <FundProjectionScreenOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '點數管理',
      icon: (
        <MoneyCollectOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '問卷管理',
      icon: (
        <CheckSquareOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '緊急修繕預算',
      icon: (
        <AlertOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '年度修繕計畫',
      icon: (
        <ToolOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '年度維護計畫',
      icon: (
        <DollarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '租賃管理',
      icon: (
        <CarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '長期修繕計畫',
      icon: (
        <DollarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '團購管理',
      icon: (
        <DollarOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '會員管理',
      icon: (
        <UsergroupAddOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '清潔打掃',
      icon: (
        <ClearOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '生活服務',
      icon: (
        <CustomerServiceOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '育樂活動',
      icon: (
        <BuildOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '待辦提醒',
      icon: (
        <CarryOutOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '公設影像',
      icon: (
        <InstagramOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '票券管理',
      icon: (
        <CreditCardOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
    {
      name: '會員點數管理',
      icon: (
        <MoneyCollectOutlined
          style={{ fontSize: '20px', color: '#08c', marginRight: '10px' }}
        />
      ),
    },
  ];

  let TopAllows = [];
  // console.log(TopAllows)
  const { location, history, match } = props;
  // console.log(location ,history ,match)
  const { pathname } = location;
  const { isCollapse } = context;
  // const [openKeys, setOpenKeys] = useState([]);
  // console.log(openKeys)
  const [userGroupRouteArr, setUserGroupRouteArr] = useState([]);
  const [currentAuth, setCurrentAuth] = useState([]);
  // console.log(currentAuth)

  const [openNavs, setOpenNavs] = useState([]); // 點擊SubNav時展開NavItem

  useEffect(() => {
    // history.listen((location, action) => {
    //   console.log(
    //     `The current URL is ${location.pathname}${location.search}${location.hash}`
    //   );
    //   console.log(`The last navigation action was ${action}`);
    // });

    client
      .reAuthenticate()
      .then((data) => {
        console.log('==relogin ok', data);

        const arr = data.user.allow
          .map((x) => {
            if (x.children) {
              for (let i = 0; i < x.children.length; i++)
                x.children[i].path = x.children[i].path.replace(
                  '/mobile',
                  '/ezpro'
                );
            }
            return x;
          })
          .sort(function (a, b) {
            return a.order - b.order;
          });
        console.log(arr);
        setCurrentAuth(arr);

        TopAllows = [...data.user.allow].concat(
          '/ezpro/home',
          '/ezpro/person',
          '/ezpro/systemSetting',
          '/ezpro/noticeRecord'
        ); // 新增allows(多個,點用方式隔開)
        // console.log("TopAllows",TopAllows)

        history.listen(({ action, location }) => {
          // 監聽Router改變  給登入狀態判斷
          HistoryListenHandle(data);
        });
      })
      .catch((err) => {
        console.log('==relogin fail', err);
        TopAllows = [];
        localStorage.removeItem('feathers-jwt');
        const nowRoute = window.location.href.split('#')[1].split('?')[0];

        if (commonhelper.isApp()) {
          // 是mobile && 在user/login這頁 > 導到3種登入頁
          commonhelper.loadPath('/com');
          return;
        } else if (JudgeRouteNoNeedAuth(nowRoute)) return; // 無登入 + 是全開頁面

        history.push('/user/login');
      });

    history.listen(({ action, location }) => {
      // 判斷For 非登入 + 自己打網址
      const nowRoute = window.location.href.split('#')[1].split('?')[0];
      if (JudgeRouteNoNeedAuth(nowRoute)) return; // 非登入 + 是全開頁面
      // if(TopAllows.length === 0)history.push('/ezpro/home');//非登入 + 不是全開頁面
    });
  }, []);

  function JudgeRouteNoNeedAuth(npath) {
    if (npath.includes('/mobile')) return true;
    const allowsPage = [
      '/user/register',
      '/user/login',
      '/user/resetPasswordVerify',
    ];
    return allowsPage.includes(npath);
  }
  function judgePageAuth(Res, npath) {
    // 拆成全子層&判斷auth
    const OutData = [];
    // if(npath=='/home' || npath=='/user/register')return true;
    if (JudgeRouteNoNeedAuth(npath)) return true;
    if (Res && Res.length > 0) {
      Res.forEach((e, nb) => {
        // 判斷allows字串
        if (typeof e === 'string') {
          OutData.push({ path: e.replace(/\b/g, '') });
          return;
        }
        // if (e.name && e.path && e.icon) OutData.push({
        //   name: e.name.replace(/\b/g, ""),
        //   path: e.path.replace(/\b/g, ""),
        //   icon: e.icon.replace(/\b/g, ""),
        //   order: e.order
        // });
        if (e.name && e.path)
          OutData.push({
            name: e.name.replace(/\b/g, ''),
            path: e.path.replace(/\b/g, ''),
            order: e.order,
          });
        if (e.children) {
          e.children.forEach((ee, nnb) => {
            if (ee.name && ee.path)
              OutData.push({
                name: ee.name.replace(/\b/g, ''),
                path: ee.path.replace(/\b/g, ''),
                order: e.order,
              });
          });
        }
      });
    }
    // console.log(OutData)
    return [...OutData].map((i) => i.path).includes(npath);
  }

  const HistoryListenHandle = (data) => {
    const nowRoute = window.location.href.split('#')[1].split('?')[0];
    // console.log(nowRoute)
    if (JudgeRouteNoNeedAuth(nowRoute)) return;
    // Router是全開頁面
    else if (!data || !data.user || !TopAllows) {
      // 無登入 + 不是全開頁面
      TopAllows = [];
      history.push('/user/login');
    } else if (!judgePageAuth(TopAllows, nowRoute)) {
      console.log(judgePageAuth(TopAllows, nowRoute));
      // 登入 + 沒有權限
      // history.push('/ezpro/home');
    }
  };

  function getNavMenuItems(menusData, initIndex) {
    if (!menusData) {
      return [];
    }

    return menusData
      .filter((item) => item.name && !item.hideInMenu)
      .map((item, index) => getSubMenuOrItem(item, `${initIndex}-${index}`));
  }

  function getSubMenuOrItem(item, index) {
    if (item.children && item.children.some((child) => child.name)) {
      const childrenItems = getNavMenuItems(item.children, index);

      if (childrenItems && childrenItems.length > 0) {
        for (let i = 0; i < iconArr.length; i++) {
          if (item.name === iconArr[i].name) {
            const subNav = (
              <SubNav
                key={index}
                label={item.name}
                icon={iconArr[i].icon}
                // selectable={true}
              >
                {childrenItems}
              </SubNav>
            );
            return subNav;
          }
        }
      }
    }

    const navItem = (
      <NavItem key={item.path}>
        <Link to={item.path}>{item.name}</Link>
      </NavItem>
    );
    return navItem;
  }

  // console.log(currentAuth);
  return (
    <Nav
      style={{ width: '200px' }}
      defaultOpenAll
      defaultSelectedKeys={[pathname]}
      hasArrow={false}
      hasTooltip
      openMode="single"
      embeddable
      // selectedKeys={[pathname]}
      // activeDirection="right"
      // openMode="single"
      // iconOnly={isCollapse}
      // hasArrow={false}
      // mode={isCollapse ? 'popup' : 'inline'} // inline
      // // openKeys={openNavs}
      // openKeys={props.closeNavItem == null ? [] : openNavs} // parent(Navbar)縮小時清空NavItem || 點擊SubNav時展開NavItem
      onOpen={(keys) => {
        // ice套件事件(SubNav)點擊
        // @ts-ignore
        // setOpenKeys(keys);

        setOpenNavs(keys); // 設定 點擊SubNav時展開NavItem
        props.setNav(keys); // 傳事件到父層 (SubNav點擊)
      }}
      onSelect={() => {
        props.setNav('NavItem');
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }}
    >
      {getNavMenuItems(currentAuth, 0)}
    </Nav>
  );
};

const PageNav = withRouter(Navigation);
export default PageNav;
